const sendFeedback = async (feedbackData, feedbackUrl, token) => {
  const options = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(feedbackData),
  };
  try {
    const res = await fetch(feedbackUrl, options);
    if (!res.ok) {
      const errorData = await res.json();
      return {
        status: "ERROR",
        data: `Failed to send feedback: ${JSON.stringify(errorData)}, response status: ${res.status}`,
      };
    }
    return {
      status: "Ok",
      data: await res.json(),
    };
  } catch (error) {
    throw new Error(`Error occurred while sending feedback:`, { cause: error });
  }
};
export default sendFeedback;
